import { Injectable } from '@angular/core';
import * as Constants from '../app.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from 'ionic-cache';
import { Evento } from '../models/evento';
import { DatePipe, formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor(
    private translateService: TranslateService,
    private httpClient: HttpClient,
    private cache: CacheService
  ) { }


  estraiDateDaEvento(obj: Evento) {
    let dataGlobaleInizio: Date;
    let dataGlobaleFine: Date;

    let today = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    obj.giorniAllEvento = -1;

    if (obj.opening) {
      obj.opening.forEach(element => {
        let dataInizioOpening: Date;
        let dataFineOpening: Date;

        if (element.startDate) {
          dataInizioOpening = new Date(
            element.startDate[0],
            element.startDate[1] - 1,
            element.startDate[2]
          );
          if (
            !dataGlobaleInizio ||
            (dataGlobaleInizio && dataInizioOpening < dataGlobaleInizio)
          ) {
            dataGlobaleInizio = dataInizioOpening;
          }
        }

        if (element.endDate) {
          dataFineOpening = new Date(
            element.endDate[0],
            element.endDate[1] - 1,
            element.endDate[2]
          );
          if (
            !dataGlobaleFine ||
            (dataGlobaleFine && dataFineOpening > dataGlobaleFine)
          ) {
            dataGlobaleFine = dataFineOpening;
          }
        }
        if (today >= dataInizioOpening && today <= dataFineOpening) {
          obj.giorniAllEvento = 0;
        } else if (dataInizioOpening > today) {
          let giorni = this.datediff(today, dataInizioOpening);

          if (
            giorni > 0 &&
            (giorni < obj.giorniAllEvento || obj.giorniAllEvento == -1)
          ) {
            obj.giorniAllEvento = giorni;
          }
        }

        //Mentre itero sui periodo, setto anche la stringa della fascia oraria
        element.periodoLong = this.formatPeriodo(
          dataInizioOpening,
          dataFineOpening,
          'long'
        );

        //Imposto la fascia oraria
        if (element.openingTimes) {
          element.openingTimes.forEach(hours => {
            if (hours.startHour && hours.endHour) {
              hours.fasciaOrariaString =
                this.toTime(hours.startHour) + '-' + this.toTime(hours.endHour);
            } else if (hours.startHour && !hours.endHour) {
              hours.fasciaOrariaString = this.toTime(hours.startHour);
            }
          });
        }
      });

      //Salvo la data iniziale e finale dell'evento
      obj.dataInizioEvento = dataGlobaleInizio;
      obj.dataFineEvento = dataGlobaleFine;

      let lang = this.translateService.currentLang;

      if (obj.dataInizioEvento) {
        obj.startDate = {};
        obj.startDate.EEEE = formatDate(obj.dataInizioEvento, 'EEEE', lang);
        obj.startDate.d = formatDate(obj.dataInizioEvento, 'd', lang);
        obj.startDate.MMMM = formatDate(obj.dataInizioEvento, 'MMMM', lang);
        obj.startDate.MMM = formatDate(obj.dataInizioEvento, 'MMM', lang);
        obj.startDate.YYYY = formatDate(obj.dataInizioEvento, 'YYYY', lang);
        obj.startDate.YY = formatDate(obj.dataInizioEvento, 'yy', lang);
      }
      if (obj.dataFineEvento) {
        obj.endDate = {};
        obj.endDate.EEEE = formatDate(obj.dataFineEvento, 'EEEE', lang);
        obj.endDate.d = formatDate(obj.dataFineEvento, 'd', lang);
        obj.endDate.MMMM = formatDate(obj.dataFineEvento, 'MMMM', lang);
        obj.endDate.MMM = formatDate(obj.dataFineEvento, 'MMM', lang);
        obj.endDate.YYYY = formatDate(obj.dataFineEvento, 'YYYY', lang);
        obj.endDate.YY = formatDate(obj.dataFineEvento, 'yy', lang);
      }



      //Salvo le stringhe per il periodo intero
      obj.periodoEventoShort = this.formatPeriodo(
        dataGlobaleInizio,
        dataGlobaleFine,
        'short'
      );
      obj.periodoEventoLong = this.formatPeriodo(
        dataGlobaleInizio,
        dataGlobaleFine,
        'long'
      );

      //Salvo il tipo di periodo dell'evento
      if (dataGlobaleInizio) {
        if (dataGlobaleFine) {
          if (
            dataGlobaleInizio.getFullYear() === dataGlobaleFine.getFullYear() &&
            dataGlobaleInizio.getMonth() === dataGlobaleFine.getMonth() &&
            dataGlobaleInizio.getDate() === dataGlobaleFine.getDate()
          ) {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_SAME_DATE;
          } else if (
            dataGlobaleInizio.getFullYear() === dataGlobaleFine.getFullYear() &&
            dataGlobaleInizio.getMonth() === dataGlobaleFine.getMonth()
          ) {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_SAME_MONTH;
          } else if (
            dataGlobaleInizio.getFullYear() === dataGlobaleFine.getFullYear()
          ) {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_DIFFERENT_MONTH_SAME_YEAR;
          } else {
            obj.periodoDurataEvento =
              Constants.TYPE_EVENTS_PERIOD.PERIOD_DIFFERENT_YEAR;
          }
        } else {
          obj.periodoDurataEvento =
            Constants.TYPE_EVENTS_PERIOD.PERIOD_ONLY_START_DATE;
        }
      } else {
        obj.periodoDurataEvento = Constants.TYPE_EVENTS_PERIOD.PERIOD_ERROR;
      }
    }
  }

  toTime(date: Date) {
    const hours = '0' + date[0];
    const minutes = '0' + date[1];
    const time =
      hours.substr(hours.length - 2) + ':' + minutes.substr(minutes.length - 2);
    return time;
  }

  datediff(first: Date, second: Date) {
    // Take the difference between the dates and divide by milliseconds per day.
    // Round to nearest whole number to deal with DST.
    return Math.round(
      (second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24)
    );
  }

  formatPeriodo(dataInizio: Date, dataFine: Date, mode: string) {
    const datePipe = new DatePipe(this.translateService.currentLang);

    let dataEvento;
    let pattern = 'dd MMMM';
    let patternWithYear = 'dd MMMM yyyy';
    if (mode === 'short') {
      pattern = 'dd MMM';
      patternWithYear = 'dd/MM/yy';
    }

    if (
      dataInizio != null &&
      dataFine != null &&
      dataInizio.getFullYear() === dataFine.getFullYear() &&
      dataInizio.getMonth() === dataFine.getMonth() &&
      dataInizio.getDate() === dataFine.getDate()
    ) {
      dataEvento = `${datePipe.transform(dataInizio, pattern)}`;
    } else if (
      dataInizio != null &&
      dataFine != null &&
      dataInizio.getFullYear() === dataFine.getFullYear() &&
      dataInizio.getMonth() === dataFine.getMonth()
    ) {
      dataEvento = `${datePipe.transform(
        dataInizio,
        pattern
      )} - ${datePipe.transform(dataFine, pattern)}`;
    } else if (
      dataInizio != null &&
      dataFine != null &&
      !(dataInizio.getFullYear() === dataFine.getFullYear()) &&
      dataInizio.getMonth() === dataFine.getMonth()
    ) {
      dataEvento = `${datePipe.transform(
        dataInizio,
        patternWithYear
      )} - ${datePipe.transform(dataFine, patternWithYear)}`;
    } else if (dataInizio != null && dataFine == null) {
      dataEvento = `${datePipe.transform(dataInizio, pattern)}`;
    } else {
      dataEvento = `${datePipe.transform(
        dataInizio,
        pattern
      )} - ${datePipe.transform(dataFine, pattern)}`;
    }
    return dataEvento;
  }

  
  formatIndirizzoEsteso(evento: any) {
    let indirizzoEsteso = ``;
    if (evento) {

      let indirizzo = '';
      let comune = '';
      let provincia = '';

      if (evento.address) {
        indirizzo = indirizzo.concat(evento.address);
        if (evento.nhouse && evento.nhouse != '0') {
          indirizzo = indirizzo.concat(`, ${evento.nhouse}`);
        }
      }
      if (evento.city) {
        comune = evento.city;
      }
      if (evento.province) {
        provincia = provincia.concat(` (`, evento.province, `)`);
      }
      
      switch (Constants.MODE_APP_LOCALE) {
        case Constants.MODE_APP_LOCALE_CITY_ADDRESS:
          indirizzoEsteso = indirizzo.concat(` - `, comune, ``);
          break;
        case Constants.MODE_APP_LOCALE_CITY:
          indirizzoEsteso = comune;
          break;
        case Constants.MODE_APP_LOCALE_ADDRESS:
          indirizzoEsteso = indirizzo;
          break;      
        default:
          break;
      }
    }

    return indirizzoEsteso;
  }



  getTagById(itemId) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_UTILITIES_URL}${Constants.BASE_TAG_URL}${Constants.PUBLIC_URL}${itemId}?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          resolve(res);
        },
        err => {
          reject(null);
        }
      );
    });
  }

  getContenutoById(itemId) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_UTILITIES_URL}${Constants.BASE_GENERIC_CONTENT_URL}${Constants.PUBLIC_URL}${itemId}?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          resolve(res);
        },
        err => {
          reject(null);
        }
      );
    });
  }

  getCotenuti() {
    return new Promise((resolve, reject) => {
      this.countCotenuti().then(
        (res: number) => {
          const path = `${Constants.API_BASE_URL}${Constants.BASE_UTILITIES_URL}${Constants.BASE_GENERIC_CONTENT_URL}${Constants.PUBLIC_URL}?landId=${environment.api.tenantId}&size=${res}`;
          this.loadFromCache(path).subscribe(
            async (res: any) => {
              resolve(res);
            },
            err => {
              reject(null);
            }
          );
        },
        err => {
          reject(null);
        });
    })
  }

  countCotenuti() {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_UTILITIES_URL}${Constants.BASE_GENERIC_CONTENT_URL}${Constants.PUBLIC_URL}count/?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          resolve(res);
        },
        err => {
          reject(null);
        }
      );

    });

  }

  loadFromCache(path) {
    if ( !this.cache ) {
      console.error('cache ERROR!');
    }
    
    this.cache.enableCache(true);

    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang
    });
    let options = { headers: headers };
    let cacheKey = path + '&' + this.translateService.currentLang;
    let request = this.httpClient.get(path, options);
    return this.cache.loadFromObservable(cacheKey, request);
  }
}
